"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const capitalize_1 = require("./capitalize");
const tokenize_1 = require("./tokenize");
/*
 * Title case the given string.
 *
 * @Param {string} text = The text to title case.
 *
 * @Example
 *
 *   titleCase('CurvedBanana')
 *   //=> "Curved Banana"
 */
function titleCase(text) {
    return tokenize_1.tokenize(text).map(capitalize_1.capitalize).join(' ');
}
exports.titleCase = titleCase;
//# sourceMappingURL=title-case.js.map